import { getBrandByHost } from "src/util/brandUtil";

const REDTRACK_SCRIPT_ID = "redtrackscript";

const redtrackScriptsByBrandId: Record<number, string> = {
	31: "/redtrack31.js",
	32: "/redtrack31.js",
	33: "/redtrack33.js",
	39: "/redtrack39.js",
	40: "/redtrack39.js",
	46: "/redtrack47.js",
	47: "/redtrack47.js",
	61: "/redtrack61.js",
};

const whiteThemeBrandIds = [46, 47];

const appendScript = (
	id: string,
	src: string,
	options: { async?: boolean; defer?: boolean } = {},
) => {
	if (document.getElementById(id)) {
		return;
	}

	const script = document.createElement("script");
	script.id = id;
	script.type = "text/javascript";
	script.src = src;
	script.async = Boolean(options.async);
	script.defer = Boolean(options.defer);
	document.head.appendChild(script);
};

const initializeRedtrack = (brand: ReturnType<typeof getBrandByHost>) => {
	if (!brand || brand.dev === "DEV") {
		return;
	}

	const scriptSrc = redtrackScriptsByBrandId[brand.id];

	if (scriptSrc) {
		appendScript(REDTRACK_SCRIPT_ID, scriptSrc, { defer: true });
	}
};

const initializeBodyTheme = (brandId?: number) => {
	document.body.classList.remove("theme-black", "theme-white");
	const themeClass = whiteThemeBrandIds.includes(Number(brandId)) ? "theme-white" : "theme-black";
	document.body.classList.add(themeClass);
};

export const initializeBrandScripts = () => {
	const brand = getBrandByHost();

	initializeBodyTheme(brand?.id);
	initializeRedtrack(brand);
};
